export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const PUSHER_KEY = process.env.REACT_APP_PUSHER_KEY;
export const PUSHER_CLUSTER = process.env.REACT_APP_PUSHER_CLUSTER;
export const ASSETS_BASE_URL =
  process.env.REACT_APP_ASSETS_BASE_URL ||
  'https://d115lxxyoq0hf3.cloudfront.net';
